import React from "react";
import { Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

// styles
import useStyles from "./styles";


function MarketingGallerySkeleton() {
  const styles = useStyles();
  return (
    <Box className={styles.galleryRoot}>
      <Box className={styles.mainImageBox}>
        <Skeleton variant="rect" className={styles.mainImage} animation="wave" />
      </Box>
      <Box className={styles.verticalImageBox}>
        <Skeleton variant="rect" className={styles.verticalImage} animation="wave" />
      </Box>
      <Box className={styles.gridImagesBox}>
        {[0,1,2,3].map(idx => (
          <Box key={idx} className={styles.gridImageWrapper}>
            <Skeleton variant="rect" className={styles.gridImage} animation="wave" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default MarketingGallerySkeleton;
